"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Receipt, Coins, ShoppingBag, Sparkles, Briefcase } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const glassCards = [{
  icon: Receipt,
  title: "Private by Design",
  description: "Your conversations are yours alone. We never train on your data or share your logs.",
  className: "absolute left-0 top-12 w-[90%] sm:w-[80%] -rotate-3 z-0 bg-white/5 backdrop-blur-xl border border-white/10 text-foreground shadow-2xl rounded-2xl p-6 sm:p-8 transition-transform duration-500 hover:rotate-0 hover:z-20"
}, {
  icon: Coins,
  title: "Zero Learning Curve",
  description: "No new apps to download or complex prompts to master. Just send a message.",
  className: "absolute right-0 top-0 w-[90%] sm:w-[80%] rotate-3 z-10 bg-white/5 backdrop-blur-xl border border-white/10 text-foreground shadow-2xl rounded-2xl p-6 sm:p-8 transition-transform duration-500 hover:rotate-0"
}];
const featureCards = [{
  icon: ShoppingBag,
  title: "Instant Access",
  description: "Start your first conversation within 60 seconds of checkout. No waiting, no setup."
}, {
  icon: Sparkles,
  title: "Global Intelligence",
  description: "Access GPT-4o, Claude 3.5, and specialized models in one unified conversational interface."
}, {
  icon: Briefcase,
  title: "Enterprise Ready",
  description: "Scale from individual use to custom on-premise deployments and private installations."
}];
export default function TheKindoAdvantage() {
  const {
    ref: topRowRef,
    isVisible: isTopRowVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: bottomRowRef,
    isVisible: isBottomRowVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="129983" id="the-oceanclaw-advantage" className="dark bg-background text-foreground relative overflow-hidden py-24 md:py-32">
      {}
      <div className="absolute inset-0 bg-gradient-to-b from-primary/10 via-background to-background pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10 max-w-7xl">
        {}
        <div ref={topRowRef} className={`grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center mb-24 transition-all duration-1000 ${isTopRowVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="lg:col-span-5 space-y-6 text-center lg:text-left">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold text-foreground leading-tight tracking-tighter">
              Intelligence that works as fast as you do
            </h2>
            <p className="text-lg md:text-xl font-default text-muted-foreground max-w-2xl mx-auto lg:mx-0">
              Private, lightning-fast, and designed for your existing workflow. OceanClaw brings high-performance AI directly to your iMessage and Slack without the complexity.
            </p>
          </div>

          {}
          <div className="lg:col-span-7 relative h-[350px] sm:h-[300px] w-full max-w-2xl mx-auto lg:mr-0 mt-8 lg:mt-0">
            {glassCards.map((card, i) => {
            const Icon = card.icon;
            return <div key={i} data-index={i} className={card.className}>
                  <div className="flex items-start gap-4">
                    <div className="bg-primary/20 p-3 rounded-full shrink-0 shadow-[0_0_15px_rgba(59,130,246,0.3)]">
                      <Icon className="w-6 h-6 text-primary" />
                    </div>
                    <div>
                      <h3 className="text-xl font-default font-semibold mb-2">{card.title}</h3>
                      <p className="font-default text-muted-foreground leading-relaxed">{card.description}</p>
                    </div>
                  </div>
                </div>;
          })}
          </div>
        </div>

        {}
        <div ref={bottomRowRef} className={`grid grid-cols-1 md:grid-cols-3 gap-8 mb-16 transition-all duration-1000 delay-200 ${isBottomRowVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {featureCards.map((card, i) => {
          const Icon = card.icon;
          return <Card key={i} data-index={i} className="bg-card border border-border/50 rounded-3xl shadow-2xl shadow-black/40 flex flex-col items-center text-center p-8 sm:p-10 hover:-translate-y-2 transition-transform duration-300">
                <CardHeader className="p-0 mb-6 flex flex-col items-center">
                  <div className="bg-primary/10 p-4 rounded-full mb-6 shadow-[0_0_20px_rgba(59,130,246,0.15)]">
                    <Icon className="w-8 h-8 text-primary" />
                  </div>
                  <CardTitle className="text-2xl font-default font-bold text-foreground mb-4">
                    {card.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="p-0">
                  <CardDescription className="text-base font-default text-muted-foreground leading-relaxed">
                    {card.description}
                  </CardDescription>
                </CardContent>
              </Card>;
        })}
        </div>

        {}
        <div className="flex justify-center mt-12">
          <Link to="#">
            <Button size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-full px-10 py-7 text-lg font-default font-bold shadow-lg shadow-primary/20 hover:shadow-xl transition-all duration-300">
              Start Now
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}